import ApiServiceNode from '../service/ApiServiceNode';
import logger from '../utils/logger';



export const departmentService = {
    // List departments
    async getDepartments({ page = 1, limit = 20, search = '', sortBy = 'name', sortOrder = 'asc' }) {
        try {
            const response = await ApiServiceNode.get('/settings/departments', {
                params: { page, limit, search, sortBy, sortOrder }
            });
            return response.data.data || response.data;
        } catch (error) {
            logger.error('Error fetching departments:', error);
            throw error;
        }
    },

    // Get single department
    async getDepartment(id) {
        try {
            const response = await ApiServiceNode.get(`/settings/departments/${id}`);
            return response.data.data || response.data;
        } catch (error) {
            logger.error('Error fetching department:', error);
            throw error;
        }
    },

    // Create department
    async createDepartment(data) {
        try {
            const response = await ApiServiceNode.post('/settings/departments', data);
            return response.data.data || response.data;
        } catch (error) {
            logger.error('Error creating department:', error);
            throw error;
        }
    },

    // Update department
    async updateDepartment(id, data) {
        try {
            const response = await ApiServiceNode.put(`/settings/departments/${id}`, data);
            return response.data.data || response.data;
        } catch (error) {
            logger.error('Error updating department:', error);
            throw error;
        }
    },

    // Delete department
    async deleteDepartment(id) {
        try {
            const response = await ApiServiceNode.delete(`/settings/departments/${id}`);
            return response.data;
        } catch (error) {
            logger.error('Error deleting department:', error);
            throw error;
        }
    },

    // Get active members count
    async getMembersCount(id) {
        try {
            const response = await ApiServiceNode.get(`/settings/departments/${id}/members`);
            return response.data.data?.count || 0;
        } catch (error) {
            logger.error('Error fetching members count:', error);
            return 0;
        }
    },

    // Get jobs count
    async getJobsCount(id) {
        try {
            const response = await ApiServiceNode.get(`/settings/departments/${id}/jobs`);
            return response.data.data?.count || 0;
        } catch (error) {
            logger.error('Error fetching jobs count:', error);
            return 0;
        }
    }
};
